import React from 'react'
import { Flex, Text } from '@workwhile/ui'
import { defs } from './defs'

export const SearchFacet = ({
  children,
  label,
}: {
  children: React.ReactNode
  label?: string
}) => (
  <Flex
    flex="1 1 auto"
    flexDirection="column"
    pt={2}
    as="label"
    width="100%"
    style={{ whiteSpace: 'nowrap' }}
  >
    {label ? (
      <Text as="span" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
        <Text mr="1" as="span" color={defs.mediumBlack}>
          &
        </Text>
        {label}
      </Text>
    ) : null}
    {children}
  </Flex>
)
